import { combineReducers } from 'redux';

import { profileReducer } from '~/store/reducers/profileReducer';

export const rootReducer = combineReducers({
  profile: profileReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
